import { req, withParams } from 'vuelidate/lib/validators/common'

export default (gt) =>
  withParams({ type: 'greater', gt }, (value) => {
    return !req(value) || Number(value) > Number(typeof gt === 'function' ? gt() : gt)
  })
